<template>

  <div class="homepage" v-if="loadedCount">
    <div class="homepage-left">
      <div class="homepage-left--top">
        the place in numbers<br>
        <span class="homepage-count" v-bind:data-count="homepage[0].count">
          0
        </span>      
        pieces<br>
        (weekly updates)
      </div>
      
      <img class="homepage-car" src="static/imgs/homepage/homepagecar.png">
      
      <div class="homepage-left--bottom">
          <h4>Welcome to the E-Type Corner</h4>
          <h3>a magic place</h3>
          <p v-html="homepage[0].body">
          </p>
          <router-link class="header-nav-button" :to="{name: 'the-magic', params: { filter: 'the-magic' }}">Read More</router-link>
      </div>
    </div>
    <div class="homepage-right">
      <router-link class="homepage-right-item" :to="{name: 'manufacturers', params: { filter: 'manufacturers' }}" v-bind:style="{ 'background-image': 'url(' + api + homepage[0].manufacturers + ')' }">
        <div class="homepage-right-item--desc">
          Manufacturers
        </div>
      </router-link>
      <router-link class="homepage-right-item" :to="{name: 'master-pieces', params: { filter: 'master-pieces' }}" v-bind:style="{ 'background-image': 'url(' + api + homepage[0].masterpieces + ')' }">
        <div class="homepage-right-item--desc">
          Master Pieces
        </div>
      </router-link>
      <router-link class="homepage-right-item" :to="{name: 'model-history', params: { filter: 'model-history' }}" v-bind:style="{ 'background-image': 'url(' + api + homepage[0].modelhistory + ')' }">
        <div class="homepage-right-item--desc">
          Model History
        </div>
      </router-link>
      <div class="homepage-right-item">
        <router-link :to="{name: 'intro', params: { filter: 'intro' }}">
          <video autoplay muted playsinline loop="loop">
            <source v-bind:src="api + homepage[0].video" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </router-link>
      </div>
    </div>
  </div>



</template>

<script>

import axios from 'axios'
import VueAxios from 'vue-axios'

export default {
  name: 'Homepage',
  data: function () {
    return {
      loadedCount: false,
      modal: false,
      api: '',
      homepage: ''
    }
  },
  methods: {
    numberCount: function () {
      $('.homepage-count').each(function () {
        var thisnum = $(this)
        var countTo = thisnum.attr('data-count')
        $({countNum: thisnum.text()}).animate({
          countNum: countTo
        },
          {
            duration: 3000,
            easing: 'swing',
            step: function () {
              thisnum.text(Math.floor(this.countNum))
            },
            complete: function () {
              thisnum.text(this.countNum)
            }
          })
      })
    },
    loadHomepage: function () {
      var app = this
      axios.get(app.api + '/admin/api/homepage').then(function (response) {
        app.homepage = response.data
        app.homepage[0].count = Number(app.homepage[0].count)
        app.loadedCount = true
        setTimeout(function () {
          app.numberCount()
        }, 900)
      })
    }

  },
  mounted () {
    this.loadHomepage()
   // this.numberCount()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>



// WEBPACK FOOTER //
// Homepage.vue?b0e4944a